import React, { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from '@mui/material';
import ReportConfigFormSection from './ReportConfigFormSection';
import {
  buildReportSettingsFromComplex,
  createEmptyReportSettingsErrors,
  serializeReportSettings,
  validateReportSettings,
} from '../../utils/reportConfig';
import { residentialComplexesApi } from '../../api/residentialComplexes';

const ReportConfigDialog = ({ open, onClose, complex, onUpdated }) => {
  const [settings, setSettings] = useState(buildReportSettingsFromComplex());
  const [errors, setErrors] = useState(createEmptyReportSettingsErrors());
  const [saving, setSaving] = useState(false);
  const [apiError, setApiError] = useState('');

  useEffect(() => {
    if (open && complex) {
      setSettings(buildReportSettingsFromComplex(complex));
      setErrors(createEmptyReportSettingsErrors());
      setApiError('');
    }
  }, [open, complex]);

  const handleSettingsChange = (next) => {
    setSettings(next);
    setErrors(validateReportSettings(next));
  };

  const handleSubmit = async () => {
    if (!complex?.id) return;
    const validation = validateReportSettings(settings);
    setErrors(validation);
    const hasErrors = Object.entries(validation).some(([key, value]) => {
      if (key === 'deviceTypeColumns') {
        return Object.values(value || {}).some(Boolean);
      }
      return Boolean(value);
    });
    if (hasErrors) return;

    const name = complex?.name?.trim();
    const address = complex?.address?.trim();
    if (!name || !address) {
      setApiError('Чтобы сохранить настройки, заполните название и адрес ЖК.');
      return;
    }

    setSaving(true);
    setApiError('');
    try {
      await residentialComplexesApi.updateResidentialComplex(
        String(complex.id),
        {
          name,
          address,
          ...serializeReportSettings(settings),
        },
      );
      onUpdated?.();
      onClose?.();
    } catch (err) {
      setApiError(err?.response?.data?.detail || err?.message || 'Не удалось сохранить настройки');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={saving ? undefined : onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Настройка выгрузки отчета</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          {apiError && <Alert severity="error">{apiError}</Alert>}
          <ReportConfigFormSection
            value={settings}
            onChange={handleSettingsChange}
            errors={errors}
            disabled={saving}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Отмена
        </Button>
        <Button onClick={handleSubmit} variant="contained" disabled={saving || !complex?.id}>
          {saving ? 'Сохранение...' : 'Сохранить'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReportConfigDialog;
